import { Link } from '@tanstack/react-router'
import { useAdminAuth } from '../../shared/auth/admin-auth-context'
import { OAuthLogin } from './oauth-login'

export function AuthPage() {
  const { status } = useAdminAuth()

  if (status === 'authenticated') {
    return (
      <div className="card-panel">
        <h2>Вы вошли как эксперт</h2>
        <p className="muted">Панель доступна.</p>
        <Link to="/trainer">
          <button>К тренажёру</button>
        </Link>
      </div>
    )
  }

  if (status === 'guest') {
    return (
      <div className="card-panel">
        <h2>Доступ ограничен</h2>
        <p className="muted">
          Этот аккаунт не имеет роли эксперта. Войдите под учётной записью эксперта или обратитесь к
          администратору.
        </p>
      </div>
    )
  }

  return (
    <div className="card-panel" style={{ maxWidth: 440, margin: '40px auto' }}>
      <h2>Вход для эксперта</h2>
      <OAuthLogin />
    </div>
  )
}
